import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
//import { FilePreviewProps } from './file-preview-props';
import { FilePreviewProps } from '@common/uploads/preview/file-preview/file-preview-props';
//import { DefaultFilePreview } from './default-file-preview';
import { ProgressCircle } from '../../../ui/progress/progress-circle';
//import { FileEntry } from '../../file-entry';
import { FileEntry } from '@common/uploads/file-entry';
//import { useFileEntryUrls } from '../../hooks/file-entry-urls';
import { useFileEntryUrls } from '@common/uploads/hooks/file-entry-urls';
import { useTrans } from '../../../i18n/use-trans';
import Quill from 'quill';
import { apiClient } from '@common/http/query-client';
import 'quill/dist/quill.snow.css';

// Import Quill's formats
const Size = Quill.import('attributors/style/size') as any;
const Font = Quill.import('attributors/style/font') as any;

// Register custom sizes
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '26px', '30px'];
Quill.register(Size, true);

export function WordDocumentFile() {
    //const entryId = 
    const { entryId } = useParams();
   // const { entry, className } = props;
    console.log('entry',entryId);
    const { trans } = useTrans();
    const editorRef = useRef<HTMLDivElement>(null);
    const [quillInstance, setQuillInstance] = useState<Quill | null>(null);
    const [showDefault, setShowDefault] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    //const [entryId, setEntryId] = useState(entry.id); // Store the entry ID in state
    //const { previewUrl } = useFileEntryUrls(entry);

    // Auto-save interval reference
    const autoSaveIntervalRef = useRef<NodeJS.Timeout | null>(null);

    // Auto-save function
    const autoSaveContent = async () => {
        if (quillInstance && entryId) {
            console.log('entryId',entryId);
            const content = quillInstance.getContents();
            try {
                await apiClient.post('file-entries/save', { id: entryId, content });
                console.log('Auto-saved successfully');
            } catch (error) {
                console.error('Auto-save failed:', error);
            }
        }
    };

    useEffect(() => {
        // Set entryId to prevent it from changing unexpectedly
       // setEntryId(entry.id);

        // if (!previewUrl || (entry.file_size && entry.file_size > 25000000)) {
        //     setShowDefault(true);
        //     return;
        // }

        // Initialize Quill editor
        if (editorRef.current && !quillInstance) {
            const quill = new Quill(editorRef.current, {
                theme: 'snow',
                readOnly: false,
                modules: {
                    toolbar: [
                        [{ 'header': [1, 2, false] }],
                        ['bold', 'italic', 'underline'],
                        ['link', 'blockquote', 'code-block', 'image'],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'size': Size.whitelist }] // Add size options in toolbar
                    ],
                },
            });
            setQuillInstance(quill);
        }

        // Load the document content into Quill for editing
        if (quillInstance) {
            setIsLoading(true);
            //buildPreviewUrl(previewUrl, entry).then(async (url) => {
              const run =   async () => {
                try {
                    const { data } = await apiClient.post('file-entries/read', {  id: entryId });
                    const quillDelta = transformToQuillDelta(data.data);
                    quillInstance.setContents(quillDelta);
                } catch (error) {
                    console.error('Error loading document:', error);
                } finally {
                    setIsLoading(false);
                }
            }
            run()
           // });

            // Start the auto-save interval
            autoSaveIntervalRef.current = setInterval(() => {
                autoSaveContent();
            }, 50000); // Save every 50 seconds
        }

        // Cleanup interval on component unmount
        return () => {
            if (autoSaveIntervalRef.current) {
                clearInterval(autoSaveIntervalRef.current);
            }
        };
    }, [entryId, quillInstance]);

    // if (showDefault) {
    //     return <DefaultFilePreview {...props} />;
    // }

    return (
        <div className={clsx( 'w-full h-full')}>
            {isLoading && <ProgressCircle />}
            <div ref={editorRef} className="w-full h-full"></div>
        </div>
    );
}


// Function to transform the API response data into Quill Delta format
function transformToQuillDelta(data: any): any {
    interface Op {
        insert: any;
        attributes?: any; // Make attributes optional
      }
      
      const ops: Op[] = [];
      

    data.forEach((element: any) => {
        if (element.type === 'section') {
            // Process each content item in the section
            element.content.forEach((contentItem: any) => {
                if (contentItem.type === 'textRun') {
                    contentItem.content.forEach((textItem: any) => {
                        if (textItem.type === 'text' && textItem.content) {
                            const attributes: any = {};

                            // Add font family, size, bold, italic, underline, and color attributes
                            if (textItem.fontAttributes) {
                                if (textItem.fontAttributes.fontFamily) {
                                    attributes.font = textItem.fontAttributes.fontFamily;
                                }
                                if (textItem.fontAttributes.fontSize) {
                                    attributes.size = `${textItem.fontAttributes.fontSize}px`;
                                }
                                if (textItem.fontAttributes.bold) {
                                    attributes.bold = true;
                                }
                                if (textItem.fontAttributes.italic) {
                                    attributes.italic = true;
                                }
                                if (textItem.fontAttributes.underline && textItem.fontAttributes.underline !== 'none') {
                                    attributes.underline = true;
                                }
                                if (textItem.fontAttributes.color) {
                                    attributes.color = `#${textItem.fontAttributes.color}`;
                                }
                            }

                            // Add the text with attributes
                            ops.push({
                                insert: textItem.content,
                                attributes: attributes, // Apply the attributes
                            });
                        } else if (textItem.type === 'image') {
                            // Handle images
                            let filePath = textItem.content.replace('zip://', '').replace(/\//g, '\\').replace(/^\\+/, '');
                            ops.push({
                                insert: { image: filePath }, // Correctly formatted file path
                            });
                        }
                    });
                    ops.push({ insert: '\n' }); // New line after each text run
                } else if (contentItem.type === 'listItem') {
                    // Handle list items
                    ops.push({
                        insert: contentItem.content,
                        attributes: { list: 'bullet' }, // Defaulting to bullet; adjust as needed
                    });

                    // Handle subItems (if any)
                    if (contentItem.subItems && contentItem.subItems.length > 0) {
                        contentItem.subItems.forEach((subItem: any) => {
                            ops.push({
                                insert: subItem.content,
                                attributes: { list: 'bullet' }, // Assuming same list type; modify as needed
                            });
                        });
                    }
                    ops.push({ insert: '\n' }); // New line after each list item
                }
            });
        }
    });

    return { ops };
}